import { render, staticRenderFns } from "./UserCards.vue?vue&type=template&id=2be4756a&scoped=true"
import script from "./UserCards.vue?vue&type=script&lang=js"
export * from "./UserCards.vue?vue&type=script&lang=js"
import style0 from "./UserCards.vue?vue&type=style&index=0&id=2be4756a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4756a",
  null
  
)

export default component.exports